import React, { useState, useCallback, useEffect } from "react";

import {
    Container,
    TitleCell,
    NoRegister,
    CellDue,
    ContainerDueDate,
    ArchevedDetail,
    TaskHeaderLeft,
    TaskTag,
    ContainerRecurrence,
    RegisterData,
    LinkData,
    LinkDataUrl,
    CellStep,
    LoaderContainer,
    DataTableCange,
    ListViewContainer,
    ActionButtonsContainer,
    ActionButton,
    ActionCountLabel,
    CountText,
    TableActionButtonsContainer,
    BtnAction
} from "./style";
import { Card } from "../../../../../../interfaces/Card";
import ContentLoader from "react-content-loader"
import { IDataTableColumn } from "react-data-table-component";
import { FieldViewProps, FilterFlowProps } from "../../../../../FilterBar/FilterDialog";
import AvatarCange from "../../../../../AvatarCange";
import { IconList, IconPickerItem } from "react-fa-icon-picker";
import { BsFillArchiveFill } from "react-icons/bs";
import Attachments from "../../../../../Colaboration/Attachments";
import { FaExternalLinkAlt, FaMailBulk, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import CheckListView from "../../CheckListField/CheckListView";
import ComboBoxFlowProgressView from "../ComboBoxFlowProgressView";
import ComboBoxFlowStepView from "../ComboBoxFlowStepView";
import { FormAnswerField } from "../../../../../../interfaces/FormAnswerField";
import { FormAnswer } from "../../../../../../interfaces/FormAnswer";
import { Flow } from "../../../../../../interfaces/Flow";
import { TbRotateClockwise } from "react-icons/tb";
import { CardFlowTag } from '../../../../../../interfaces/CardFlowTag';
import { User } from "../../../../../../interfaces/User";
import getFields from "../../../../../../utils/getFields";
import { FieldProps } from "../../../FieldBuilder";
import { styled, Tooltip, TooltipProps } from "@material-ui/core";
import DialogAction from "../../../../../../dialogs/DialogAction";
import { useCardDialog } from "../../../../../../hooks/cardDialogContext";

const customStyles = {
    headRow: {
        style: {
            borderTop: 'solid 0.5px #e0e0e0'
        },
    },
    headCells: {
        style: {
            color: 'black',
            fontSize: '14px',
            //fontWeight: 400,
            borderBottom: 'solid 0.5px #e0e0e0',
            borderRight: 'solid 0.5px #e0e0e0',
            borderLeft: 'solid 0.5px #e0e0e0',

        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: '#f4f4f4',
            borderBottomColor: '#FFFFFF',
            outline: '1px solid white',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
    cells: {
        style: {
            borderRight: 'solid 0.5px #e0e0e0',
            borderLeft: 'solid 0.5px #e0e0e0'
        }
    },
};

interface ColumnSizeProps {
    id_field: number;
    width: number;
}

const LoaderTable = () => (
    <ContentLoader
        speed={2}
        height={500}
        width={'100%'}
        backgroundColor="#ffffff"
        foregroundColor="#f4f5f7"
    >
        <rect x="0" y="0" rx="0" ry="0" width="350px" height="55px" />
        <rect x="355" y="0" rx="0" ry="0" width="200px" height="55px" />
        <rect x="560" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="745" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="930" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="1115" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="1300" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="1485" y="0" rx="0" ry="0" width="180px" height="55px" />
        <rect x="1670" y="0" rx="0" ry="0" width="4000px" height="55px" />

        <rect x="0" y="60" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="115" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="170" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="225" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="280" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="335" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="390" rx="0" ry="0" width="4000px" height="50px" />
        <rect x="0" y="445" rx="0" ry="0" width="4000px" height="50px" />
    </ContentLoader>
)

const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    "& .MuiTooltip-tooltip.MuiTooltip-tooltipPlacementBottom": {
        backgroundColor: "#1F2D32",
        color: 'white',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));

interface ComboBoxFlowTableProps {
    flow: Flow;
    typeUser: string;
    cards?: Card[];
    filterFlow?: FilterFlowProps;
    isSelectableRows?: boolean;
    loading?: boolean
    onRowClicked: (row: Card) => Promise<void> | void;
    onRemoveCard?: (cards: number[]) => Promise<void> | void;
    onSelectCards?: (cards: Card[]) => Promise<void> | void;
}

const ComboBoxFlowTable: React.FC<ComboBoxFlowTableProps> = ({ cards, filterFlow, flow, typeUser, loading, onRowClicked, isSelectableRows = true, onRemoveCard, onSelectCards }) => {

    const { openRegister } = useCardDialog();

    const [subHeaderAlign] = useState('right');
    const [noHeader] = useState(true);
    const [columnConfig, setColumnConfig] = useState<IDataTableColumn[]>();
    const [cardsSelected, setCardsSelected] = useState<Card[]>([]);
    const [showRemoveDialog, setShowRemoveDialog] = useState(false);

    const [toggledClearRows, setToggleClearRows] = React.useState(false);

    const handleClearRows = useCallback(() => {
        setToggleClearRows(!toggledClearRows);
    }, [toggledClearRows]);

    const handleShowRemoveDialog = useCallback(() => {
        setShowRemoveDialog(true);
    }, []);

    const handleRemoveDialogConfirm = useCallback(async () => {
        if (onRemoveCard && cardsSelected && cardsSelected.length > 0) {
            const cardIds = cardsSelected.map(card => card.id_card);
            onRemoveCard(cardIds);
            handleClearRows();
            setShowRemoveDialog(false);
            setCardsSelected([]);

        }

    }, [cardsSelected, onRemoveCard, handleClearRows]);

    const handleSelectRows = (object: {
        allSelected: boolean;
        selectedCount: number;
        selectedRows: any[];
    }) => {

        if (object.selectedRows !== undefined) {
            setCardsSelected(object.selectedRows);

            if (toggledClearRows) {
                setToggleClearRows(!toggledClearRows);
            }
        }

    };

    const getColumnsConfig = useCallback((columnsSize?: ColumnSizeProps[], fieldView?: FieldViewProps[], fields?: FieldProps[]) => {

        let newColumnConfig: IDataTableColumn[] = [];

        let isControledByFieldView = false;
        if (fieldView !== undefined && fieldView.length > 0) {
            isControledByFieldView = true;
        }

        const columnWidthTitle = columnsSize?.filter((col) => col.id_field === -6);
        const columnWidthTags = columnsSize?.filter((col) => col.id_field === -4);

        //Fields Default
        const idStep = -5;
        const colStep: IDataTableColumn = {
            id: idStep,
            name: "Etapa",
            cell: (row) => {
                return (
                    <>
                        {row.archived === "S" ? <ArchevedDetail><BsFillArchiveFill /></ArchevedDetail> : <></>}
                        <DarkTooltip title={
                            <React.Fragment>
                                <div>{row.flow_step?.name}</div>
                            </React.Fragment>
                        }>
                            <CellStep onClick={() => onRowClicked(row)} color={row.flow_step?.color}>
                                {row.flow_step?.icon !== undefined ?
                                    <IconPickerItem
                                        icon={row.flow_step?.icon as IconList}
                                        color={"white"}
                                    /> :
                                    <FaMailBulk />
                                }
                            </CellStep>
                        </DarkTooltip>
                    </>
                )
            },
            minWidth: "40px",
            center: true,
        }
        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {
            const idx = fieldView.findIndex((fv) => fv.id_field === idStep);
            if (idx !== undefined && fieldView[idx] !== undefined) {
                if (fieldView[idx].active) {
                    newColumnConfig.push(colStep);
                }
            }
        } else {
            newColumnConfig.push(colStep);
        }

        //Fields Default
        const idTitle = -6;
        const colTitle: IDataTableColumn = {
            id: idTitle,
            name: "Título",
            cell: (row) => {
                return (
                    <TitleCell onClick={() => onRowClicked(row)}>
                        {row.title}
                    </TitleCell>
                )
            },
            minWidth: columnWidthTitle !== undefined && columnWidthTitle.length > 0 ? columnWidthTitle[0].width + "px" : "200px",
            allowOverflow: true
        }
        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {
            const idx = fieldView.findIndex((fv) => fv.id_field === idTitle);
            if (idx !== undefined && fieldView[idx] !== undefined) {
                if (fieldView[idx].active) {
                    newColumnConfig.push(colTitle);
                }
            }
        } else {
            newColumnConfig.push(colTitle);
        }

        //Fields Default
        const idAssigned = -3;
        const colAssigned: IDataTableColumn = {
            id: idAssigned,
            name: "Responsável",
            cell: (row) => {
                return (
                    row.user !== undefined && (
                        <AvatarCange user={row.user as User} size="35" />
                    )
                )
            },
            minWidth: "100px",
            center: true
        }
        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {
            const idx = fieldView.findIndex((fv) => fv.id_field === idAssigned);
            if (idx !== undefined && fieldView[idx] !== undefined) {
                if (fieldView[idx].active) {
                    newColumnConfig.push(colAssigned);
                }
            }
        } else if (fields === undefined || fields.length <= 0) {
            newColumnConfig.push(colAssigned);
        }

        //Fields Default
        const idDue = -2;
        const colDue: IDataTableColumn = {
            id: idDue,
            name: "Vencimento",
            cell: (row) => {

                //complete: null // complete: "S"
                //status_dt_due: 3
                //0 - Vencido / 1 - Vence Hoje / 2 = Vence Amanhã / 3 = Vence depois ou Sem dt Due

                let colorDue;
                let label = row.dt_due_string;

                if (row.status_dt_due !== undefined) {
                    if (row.status_dt_due === 0) {
                        colorDue = "#fe4941";
                    } else if (row.status_dt_due === 1) {
                        colorDue = "#60bd4f";
                        label = "Hoje";
                    } else if (row.status_dt_due === 2) {
                        colorDue = "#60bd4f";
                        label = "Amanhã";
                    } else if (row.status_dt_due === 3) {
                        colorDue = "gray";
                    }
                }

                return (
                    <ContainerDueDate>
                        {row.on_recurrence === "S" && (
                            <ContainerRecurrence title="Este cartão possui uma recorrência ativa">
                                <TbRotateClockwise />
                            </ContainerRecurrence>
                        )}
                        {row.dt_due !== undefined && row.dt_due !== null && (
                            row.complete !== undefined && row.complete === "S" ?
                                <CellDue color={colorDue}><s>{label}</s></CellDue> :
                                <CellDue color={colorDue}>{label}</CellDue>
                        )}
                    </ContainerDueDate>
                )
            },
            minWidth: "175px",
            center: true
        }
        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {
            const idx = fieldView.findIndex((fv) => fv.id_field === idDue);
            if (idx !== undefined && fieldView[idx] !== undefined) {
                if (fieldView[idx].active) {
                    newColumnConfig.push(colDue);
                }
            }
        } else if (fields === undefined || fields.length <= 0) {
            newColumnConfig.push(colDue);
        }

        //Fields Default
        const idTag = -4;
        const colTag: IDataTableColumn = {
            id: idTag,
            name: "Etiquetas",
            cell: (row) => {
                return (
                    row.card_flow_tags !== undefined && row.card_flow_tags.length > 0 && (
                        <TaskHeaderLeft>
                            {row.card_flow_tags?.map((tag: CardFlowTag) => {
                                return (
                                    <TaskTag key={tag.id_card_flow_tag} color={tag.flow_tag.color}>{tag.flow_tag.description}</TaskTag>
                                );
                            })}
                        </TaskHeaderLeft>
                    )
                )
            },
            minWidth: columnWidthTags !== undefined && columnWidthTags.length > 0 ? columnWidthTags[0].width + "px" : "175px",
            center: true,
        }
        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {
            const idx = fieldView.findIndex((fv) => fv.id_field === idTag);
            if (idx !== undefined && fieldView[idx] !== undefined) {
                if (fieldView[idx].active) {
                    newColumnConfig.push(colTag);
                }
            }
        } else if (fields === undefined || fields.length <= 0) {
            newColumnConfig.push(colTag);
        }

        if (isControledByFieldView && fieldView !== undefined && fieldView.length > 0) {

            const fieldViewActive = fieldView.filter((fv) => fv.active);

            if (fieldViewActive !== undefined && fieldViewActive.length > 0) {
                for (let index = 0; index < fieldViewActive.length; index++) {
                    const fv = fieldViewActive[index];

                    //Find the field object
                    let fieldObj = flow.form_init?.fields.find((field) => field.id_field === fv.id_field);
                    if (fieldObj === undefined) {
                        for (let indexStep = 0; indexStep < flow.flow_steps.length; indexStep++) {
                            const s = flow.flow_steps[indexStep];
                            const foundField = s.form.fields.find((f) => f.id_field === fv.id_field);
                            if (foundField) {
                                fieldObj = foundField;
                                break;
                            }
                        }
                    }

                    if (fieldObj !== undefined && fieldObj.id_field !== undefined) {
                        const columnWidth = columnsSize?.filter((col) => col.id_field === fv.id_field);

                        const column: IDataTableColumn = {
                            id: fv.id_field,
                            name: fv.title.toString(),
                            cell: (row) => {

                                let value: FormAnswerField[] | undefined = undefined;

                                if (row.form_answers !== undefined && row.form_answers.length > 0) {
                                    //Filter the form answer with the same form_id
                                    const formAnswer = row.form_answers.filter((answer: FormAnswer) => answer.form_id === fv.form_id);

                                    //Get the form answer with the biggest id
                                    let newerFormAnswer: FormAnswer | undefined = undefined;
                                    if (formAnswer !== undefined && formAnswer.length > 1) {
                                        newerFormAnswer = formAnswer.reduce((prev: FormAnswer, current: FormAnswer) => (prev.id_form_answer > current.id_form_answer) ? prev : current);
                                    } else {
                                        newerFormAnswer = formAnswer[0];
                                    }

                                    //Get the form answer field with the same field_id
                                    if (newerFormAnswer !== undefined && newerFormAnswer.form_answer_fields !== undefined && newerFormAnswer.form_answer_fields.length > 0) {
                                        value = newerFormAnswer.form_answer_fields.filter((answer: FormAnswerField) => answer.field_id === fv.id_field);
                                    }
                                } else {
                                    value = undefined;
                                }

                                const isMultiple = fv.type === "COMBO_BOX_REGISTER_FIELD" || fv.type === "COMBO_BOX_FLOW_FIELD" || fv.type === "INPUT_LIST_FIELD" || fv.type === "CHECK_BOX_FIELD" || fv.type === "COMBO_BOX_FIELD" ? true : false;

                                return (

                                    value === undefined || value.length <= 0 ?
                                        <div key={index} onClick={() => onRowClicked(row)}>
                                            <NoRegister>Sem registro</NoRegister>
                                        </div> :

                                        fv.type === "CHECK_LIST_FIELD" ?
                                            <CheckListView key={-1} value={value} onlyPercent /> :
                                            fv.type === "COMBO_BOX_FLOW_FIELD" && String(fv.maxLength) === "2" && value.length >= 1 ?
                                                <ComboBoxFlowProgressView key={-1} value={value} /> :
                                                fv.type === "COMBO_BOX_FLOW_FIELD" && value.length >= 1 ?
                                                    <ComboBoxFlowStepView key={-1} value={value} /> :
                                                    fv.type === "LINK_FIELD" && value[0] !== undefined ?
                                                        <a key={index} href={value[0].value} target="_blank" rel="noreferrer">
                                                            <LinkData key={index} color={"#4681b81e"}>
                                                                <LinkDataUrl>
                                                                    {value[0].value}
                                                                </LinkDataUrl>
                                                                <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                            </LinkData>
                                                        </a> :

                                                        value.map((val, index) => {
                                                            return (
                                                                isMultiple && val.relatedOrigin !== undefined && val.relatedOrigin === 'register' ?
                                                                    <Link key={index} to={"/register/" + val.relatedOriginHash + "/register/" + val.relatedId} style={{ textDecoration: 'none' }} target="_blank">
                                                                        <RegisterData key={index} color={val.relatedOriginColor}>
                                                                            {val.valueString}
                                                                            <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                                        </RegisterData>
                                                                    </Link> :
                                                                    isMultiple && val.relatedOrigin !== undefined && val.relatedOrigin === 'flow' ?
                                                                        <Link key={index} to={"/flow/" + val.relatedOriginHash + "/card/" + val.relatedId} style={{ textDecoration: 'none' }} target="_blank">
                                                                            <RegisterData key={index} color={val.relatedOriginColor}>
                                                                                {val.valueString}
                                                                                <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                                            </RegisterData>
                                                                        </Link> :
                                                                        fv.type === "INPUT_ATTACH_FIELD" && val.valueAttachment !== undefined ?
                                                                            <Attachments
                                                                                key={val.valueAttachment?.id_attachment}
                                                                                uploadedFiles={[val.valueAttachment]}
                                                                                maxLength={"1"} typeUser={"V"}
                                                                                variation={fv.variation}
                                                                                card_current_id={row.id_card}
                                                                                flow_id={row.flow_id}
                                                                                widget='highlight'
                                                                            /> :
                                                                            <div key={index} onClick={() => onRowClicked(row)}>
                                                                                {isMultiple ?
                                                                                    <RegisterData key={index}>{val.valueString}</RegisterData> :
                                                                                    <div key={val.id_form_answer_field + val.index}>{val.valueString}</div>
                                                                                }
                                                                            </div>
                                                            )
                                                        })

                                )
                            },
                            minWidth: columnWidth !== undefined && columnWidth.length > 0 ? columnWidth[0].width + "px" : "175px",
                            allowOverflow: false,
                            center: fv.type === "DATE_PICKER_FIELD" || fv.type === "DUE_DATE_FIELD" ? true : false
                        }

                        newColumnConfig.push(column);

                    }

                }
            }

            //Order the array
            newColumnConfig = newColumnConfig.sort((a: IDataTableColumn, b: IDataTableColumn) => {
                // First priority: id_field -5 (Etapa) always comes first
                if ((a.id as number) === -5) return -1; // a is id -5, it comes first
                if ((b.id as number) === -5) return 1;  // b is id -5, it comes first

                // Second priority: items with id_field < 0 come before id_field >= 0
                if ((a.id as number) < 0 && (b.id as number) >= 0) {
                    return -1; // a comes first
                }
                if ((a.id as number) >= 0 && (b.id as number) < 0) {
                    return 1; // b comes first
                }

                // Third priority: sort by flow structure
                // Check if both fields are custom fields (id >= 0)
                if (fields !== undefined && (a.id as number) >= 0 && (b.id as number) >= 0) {
                    const fieldA = fields.find((f) => f.id_field === a.id);
                    const fieldB = fields.find((f) => f.id_field === b.id);

                    if (fieldA && fieldB) {
                        // Check if fields are from the flow.form_init (which should come first)
                        const isAFromInitForm = fieldA.form_id === flow.form_init_id;
                        const isBFromInitForm = fieldB.form_id === flow.form_init_id;

                        // If one is from init form and the other isn't, init form comes first
                        if (isAFromInitForm && !isBFromInitForm) return -1;
                        if (!isAFromInitForm && isBFromInitForm) return 1;

                        // If both are from the same form, sort by field index
                        if (fieldA.form_id === fieldB.form_id) {
                            return fieldA.index - fieldB.index;
                        }

                        // If they're from different forms, find the steps they belong to
                        const stepA = flow.flow_steps.find(step => step.form.id_form === fieldA.form_id);
                        const stepB = flow.flow_steps.find(step => step.form.id_form === fieldB.form_id);

                        // Sort by step index
                        if (stepA && stepB) {
                            return stepA.index - stepB.index;
                        }

                        // If only one is found in steps, prioritize the one that's defined
                        if (stepA) return -1;
                        if (stepB) return 1;
                    }
                }

                if (fields !== undefined) {
                    // Fourth priority: if both are < 0, follow the existing rule
                    const findPositionA = fields.find((f) => f.id_field === a.id);
                    const findPositionB = fields.find((f) => f.id_field === b.id);

                    if (findPositionA !== undefined && findPositionB !== undefined) {
                        return findPositionA.index - findPositionB.index;
                    }

                    if (findPositionA === undefined) {
                        return 1;
                    }

                    if (findPositionB === undefined) {
                        return -1;
                    }
                }

                return 0;
            });
        } else if (fields !== undefined && fields.length > 0) {
            for (let index = 0; index < fields.length; index++) {
                const fv = fields[index];

                //Find the field object
                let fieldObj = flow.form_init?.fields.find((field) => field.id_field === fv.id_field);
                if (fieldObj === undefined) {
                    for (let indexStep = 0; indexStep < flow.flow_steps.length; indexStep++) {
                        const s = flow.flow_steps[indexStep];
                        const foundField = s.form.fields.find((f) => f.id_field === fv.id_field);
                        if (foundField) {
                            fieldObj = foundField;
                            break;
                        }
                    }
                }

                if (fieldObj !== undefined && fieldObj.id_field !== undefined) {
                    const columnWidth = columnsSize?.filter((col) => col.id_field === fv.id_field);

                    const column: IDataTableColumn = {
                        id: fv.id_field,
                        name: fv.title.toString(),
                        cell: (row) => {

                            let value: FormAnswerField[] | undefined = undefined;

                            if (row.form_answers !== undefined && row.form_answers.length > 0) {
                                //Filter the form answer with the same form_id
                                const formAnswer = row.form_answers.filter((answer: FormAnswer) => answer.form_id === fv.form_id);

                                //Get the form answer with the biggest id
                                let newerFormAnswer: FormAnswer | undefined = undefined;
                                if (formAnswer !== undefined && formAnswer.length > 1) {
                                    newerFormAnswer = formAnswer.reduce((prev: FormAnswer, current: FormAnswer) => (prev.id_form_answer > current.id_form_answer) ? prev : current);
                                } else {
                                    newerFormAnswer = formAnswer[0];
                                }

                                //Get the form answer field with the same field_id
                                if (newerFormAnswer !== undefined && newerFormAnswer.form_answer_fields !== undefined && newerFormAnswer.form_answer_fields.length > 0) {
                                    value = newerFormAnswer.form_answer_fields.filter((answer: FormAnswerField) => answer.field_id === fv.id_field);
                                }
                            } else {
                                value = undefined;
                            }

                            const isMultiple = fv.type === "COMBO_BOX_REGISTER_FIELD" || fv.type === "COMBO_BOX_FLOW_FIELD" || fv.type === "INPUT_LIST_FIELD" || fv.type === "CHECK_BOX_FIELD" || fv.type === "COMBO_BOX_FIELD" ? true : false;

                            return (

                                value === undefined || value.length <= 0 ?
                                    <div key={index} onClick={() => onRowClicked(row)}>
                                        <NoRegister>Sem registro</NoRegister>
                                    </div> :

                                    fv.type === "CHECK_LIST_FIELD" ?
                                        <CheckListView key={-1} value={value} onlyPercent /> :
                                        fv.type === "COMBO_BOX_FLOW_FIELD" && String(fv.maxLength) === "2" && value.length >= 1 ?
                                            <ComboBoxFlowProgressView key={-1} value={value} /> :
                                            fv.type === "COMBO_BOX_FLOW_FIELD" && value.length >= 1 ?
                                                <ComboBoxFlowStepView key={-1} value={value} /> :
                                                fv.type === "LINK_FIELD" && value[0] !== undefined ?
                                                    <a key={index} href={value[0].value} target="_blank" rel="noreferrer">
                                                        <LinkData key={index} color={"#4681b81e"}>
                                                            <LinkDataUrl>
                                                                {value[0].value}
                                                            </LinkDataUrl>
                                                            <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                        </LinkData>
                                                    </a> :

                                                    value.map((val, index) => {
                                                        return (
                                                            isMultiple && val.relatedOrigin !== undefined && val.relatedOrigin === 'register' ?
                                                                <RegisterData key={index} color={val.relatedOriginColor} onClick={() => val.valueRegister !== undefined && val.valueRegister?.register !== undefined ? openRegister(val.valueRegister, val.valueRegister?.register) : {}}>
                                                                    {val.valueString}
                                                                    <Link key={index} to={"/register/" + val.relatedOriginHash + "/register/" + val.relatedId} style={{ textDecoration: 'none', color: 'gray' }} target="_blank">
                                                                        <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                                    </Link>
                                                                </RegisterData >
                                                                :
                                                                isMultiple && val.relatedOrigin !== undefined && val.relatedOrigin === 'flow' ?
                                                                    <Link key={index} to={"/flow/" + val.relatedOriginHash + "/card/" + val.relatedId} style={{ textDecoration: 'none' }} target="_blank">
                                                                        <RegisterData key={index} color={val.relatedOriginColor}>
                                                                            {val.valueString}
                                                                            <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                                                        </RegisterData>
                                                                    </Link> :
                                                                    fv.type === "INPUT_ATTACH_FIELD" && val.valueAttachment !== undefined ?
                                                                        <Attachments
                                                                            key={val.valueAttachment?.id_attachment}
                                                                            uploadedFiles={[val.valueAttachment]}
                                                                            maxLength={"1"} typeUser={"V"}
                                                                            variation={fv.variation}
                                                                            card_current_id={row.id_card}
                                                                            flow_id={row.flow_id}
                                                                            widget='highlight'
                                                                        /> :
                                                                        <div key={index} onClick={() => onRowClicked(row)}>
                                                                            {isMultiple ?
                                                                                <RegisterData key={index}>{val.valueString}</RegisterData> :
                                                                                <div key={val.id_form_answer_field + val.index}>{val.valueString}</div>
                                                                            }
                                                                        </div>
                                                        )
                                                    })

                            )
                        },
                        minWidth: columnWidth !== undefined && columnWidth.length > 0 ? columnWidth[0].width + "px" : "175px",
                        allowOverflow: false,
                        center: fv.type === "DATE_PICKER_FIELD" || fv.type === "DUE_DATE_FIELD" ? true : false
                    }

                    newColumnConfig.push(column);

                }

            }

            //Order the array
            newColumnConfig = newColumnConfig.sort((a: IDataTableColumn, b: IDataTableColumn) => {
                // First priority: id_field -5 (Etapa) always comes first
                if ((a.id as number) === -5) return -1; // a is id -5, it comes first
                if ((b.id as number) === -5) return 1;  // b is id -5, it comes first

                // Second priority: items with id_field < 0 come before id_field >= 0
                if ((a.id as number) < 0 && (b.id as number) >= 0) {
                    return -1; // a comes first
                }
                if ((a.id as number) >= 0 && (b.id as number) < 0) {
                    return 1; // b comes first
                }

                // Third priority: sort by flow structure
                // Check if both fields are custom fields (id >= 0)
                if ((a.id as number) >= 0 && (b.id as number) >= 0) {
                    const fieldA = fields.find((f) => f.id_field === a.id);
                    const fieldB = fields.find((f) => f.id_field === b.id);

                    if (fieldA && fieldB) {
                        // Check if fields are from the flow.form_init (which should come first)
                        const isAFromInitForm = fieldA.form_id === flow.form_init_id;
                        const isBFromInitForm = fieldB.form_id === flow.form_init_id;

                        // If one is from init form and the other isn't, init form comes first
                        if (isAFromInitForm && !isBFromInitForm) return -1;
                        if (!isAFromInitForm && isBFromInitForm) return 1;

                        // If both are from the same form, sort by field index
                        if (fieldA.form_id === fieldB.form_id) {
                            return fieldA.index - fieldB.index;
                        }

                        // If they're from different forms, find the steps they belong to
                        const stepA = flow.flow_steps.find(step => step.form.id_form === fieldA.form_id);
                        const stepB = flow.flow_steps.find(step => step.form.id_form === fieldB.form_id);

                        // Sort by step index
                        if (stepA && stepB) {
                            return stepA.index - stepB.index;
                        }

                        // If only one is found in steps, prioritize the one that's defined
                        if (stepA) return -1;
                        if (stepB) return 1;
                    }
                }

                // Fourth priority: if both are < 0, follow the existing rule
                const findPositionA = fields.find((f) => f.id_field === a.id);
                const findPositionB = fields.find((f) => f.id_field === b.id);

                if (findPositionA !== undefined && findPositionB !== undefined) {
                    return findPositionA.index - findPositionB.index;
                }

                if (findPositionA === undefined) {
                    return 1;
                }

                if (findPositionB === undefined) {
                    return -1;
                }

                return 0;
            });
        }

        return newColumnConfig;

    }, [onRowClicked, flow, openRegister]);

    const handleColumnsSize = useCallback(() => {

        //Get the size of columns
        let columnsSize: ColumnSizeProps[] = [];
        let sizeByPixel = 7.5;
        let fields: FieldProps[] = [];

        if (flow !== undefined && flow.form_init !== undefined) {

            fields = getFields(flow.form_init, flow.flow_steps);

            //Filter just the fields that has card_highlight
            if (fields !== undefined && fields.length > 0) {
                fields = fields.filter((field) => field.card_highlight === "1");
            }

            if (cards !== undefined && cards.length > 0) {

                //Title
                const idTitle = -6;
                const maxSizeTitle = 400;
                const minSizeTitle = 200;

                //Tags
                const idTags = -4;
                const maxSizeTags = 400;
                const minSizeTags = 30;
                const plusSpaceTags = 3;

                //Step
                const idStep = -5;
                const maxSizeStep = 350;
                const minSizeStep = 175;

                //Title Fixed
                const maxLength = cards.reduce((max, card) => {
                    const stringLength = card.title !== undefined && card.title !== null ? card.title.length : 0;
                    return stringLength > max ? stringLength : max;
                }, 0);
                const sizeColumn = maxLength * (sizeByPixel + 1);
                columnsSize.push({
                    id_field: idTitle,
                    width: sizeColumn < minSizeTitle ? minSizeTitle : sizeColumn > maxSizeTitle ? maxSizeTitle : sizeColumn
                } as ColumnSizeProps);

                for (let indexField = 0; indexField < fields.length; indexField++) {
                    const fv = fields[indexField];

                    if (fv.id_field === idTitle) { //Title

                        const maxLength = cards.reduce((max, card) => {
                            const stringLength = card.title !== undefined && card.title !== null ? card.title.length : 0;
                            return stringLength > max ? stringLength : max;
                        }, 0);

                        const sizeColumn = maxLength * (sizeByPixel + 1);

                        columnsSize.push({
                            id_field: fv.id_field,
                            width: sizeColumn < minSizeTitle ? minSizeTitle : sizeColumn > maxSizeTitle ? maxSizeTitle : sizeColumn
                        } as ColumnSizeProps);

                    } else if (fv.id_field === idTags) { //Tags

                        const maxLength = cards.reduce((max, card) => {
                            const stringLength = card.card_flow_tags !== undefined && card.card_flow_tags.length > 0 ? card.card_flow_tags.length * 10 : 0;
                            return stringLength > max ? stringLength : max;
                        }, 0);

                        const sizeColumn = (maxLength + plusSpaceTags) * (sizeByPixel);

                        columnsSize.push({
                            id_field: fv.id_field,
                            width: sizeColumn < minSizeTags ? minSizeTags : sizeColumn > maxSizeTags ? maxSizeTags : sizeColumn
                        } as ColumnSizeProps);


                    } else if (fv.id_field === idStep) { //Step

                        const maxLength = cards.reduce((max, card) => {
                            const stringLength = card.flow_step !== undefined && card.flow_step.name !== undefined ? card.flow_step.name.length : 0;
                            return stringLength > max ? stringLength : max;
                        }, 0);

                        const sizeColumn = maxLength * (sizeByPixel + 3);

                        columnsSize.push({
                            id_field: fv.id_field,
                            width: sizeColumn < minSizeStep ? minSizeStep : sizeColumn > maxSizeStep ? maxSizeStep : sizeColumn
                        } as ColumnSizeProps);
                    } else {

                        const plusSpace: number = fv.type === "COMBO_BOX_REGISTER_FIELD" || fv.type === "COMBO_BOX_FLOW_FIELD" ? 60 : 0;
                        const maxSize = 400;
                        const minSize = 120;
                        let countFields = 1;

                        const maxValueStringLength = cards.reduce((max, card) => {
                            if (card.form_answers !== undefined && card.form_answers.length > 0) {
                                const fa = card.form_answers.filter((faf) => faf.form_id === fv.form_id).sort((a, b) => b.id_form_answer - a.id_form_answer);

                                if (fa !== undefined && fa.length > 0) {

                                    const faf = fa[0].form_answer_fields.filter((faf) => faf.field_id === fv.id_field);

                                    countFields = faf.length >= countFields ? faf.length : countFields;

                                    if (faf.length >= 2) {
                                        countFields = 2;
                                    }

                                    if (faf !== undefined && faf.length > 0) {
                                        const valueStringLength = faf[0] !== undefined && faf[0].valueString !== undefined ? faf[0].valueString.length : 0;

                                        return valueStringLength > max ? valueStringLength : max;
                                    }
                                }
                            }
                            return max;
                        }, 0);

                        let sizeColumn = maxValueStringLength !== undefined ? maxValueStringLength * sizeByPixel : 100;
                        sizeColumn = sizeColumn < minSize ? minSize : sizeColumn > maxSize ? maxSize : sizeColumn;

                        let finalWidth = (sizeColumn * countFields) + plusSpace;

                        //Default Value
                        if (fv.type === "CHECK_LIST_FIELD") {
                            finalWidth = 300;
                        } else if (fv.type === "COMBO_BOX_FLOW_FIELD") {
                            finalWidth = 400;
                        } else if (fv.type === "INPUT_ATTACH_FIELD") {
                            finalWidth = 340 * countFields;
                        }

                        columnsSize.push({
                            id_field: fv.id_field,
                            width: finalWidth
                        } as ColumnSizeProps);

                    }

                }
            }

        }

        if (columnsSize !== undefined && columnsSize.length > 0) {
            const columnConfig = getColumnsConfig(columnsSize, filterFlow?.fieldView, fields);
            return columnConfig;
        }

        return undefined;

    }, [cards, getColumnsConfig, filterFlow, flow]);

    useEffect(() => {

        const newColumnConfig = handleColumnsSize();

        setColumnConfig(newColumnConfig);

    }, [cards, handleColumnsSize]);

    return (
        <Container className="comboBoxFlowTable-Container">
            {loading ?
                <LoaderContainer>
                    <LoaderTable />
                </LoaderContainer> :
                columnConfig !== undefined && cards !== undefined ?
                    <>
                        {cardsSelected && cardsSelected.length > 0 && (
                            <ActionButtonsContainer>
                                <ActionCountLabel>
                                    {cardsSelected.length} {cardsSelected.length === 1 ? 'item selecionado' : 'itens selecionados'}
                                </ActionCountLabel>
                                {onRemoveCard && (
                                    <ActionButton type="button" className="delete" onClick={handleShowRemoveDialog}>
                                        <FaTrash /> Remover
                                    </ActionButton>
                                )}
                            </ActionButtonsContainer>
                        )}
                        <ListViewContainer>
                            <DataTableCange
                                className="tableCange"
                                columns={columnConfig}
                                data={cards}
                                subHeaderAlign={subHeaderAlign}
                                noHeader={noHeader}
                                customStyles={customStyles}
                                striped={true}
                                onRowClicked={typeUser !== "V" ? onRowClicked : undefined}
                                highlightOnHover={true}
                                noDataComponent={<div style={{ color: 'black', margin: '10px', padding: '20px', fontWeight: '500' }}>Não encontramos nenhum registro com os filtros escolhidos!</div>}
                                pointerOnHover
                                sortServer={false}
                                /* Selectable Rows */
                                selectableRows={isSelectableRows}
                                onSelectedRowsChange={isSelectableRows ? handleSelectRows : undefined}
                                clearSelectedRows={toggledClearRows}
                                color={flow !== undefined && flow.color !== undefined ? flow.color : "#9e37ed"}
                            />

                            <CountText>
                                {cards.length} {cards.length === 1 ? 'registro' : 'registros'}
                            </CountText>

                            <div style={{ marginBottom: '10px' }} />
                        </ListViewContainer>

                        {cardsSelected && cardsSelected.length > 0 && (
                            <TableActionButtonsContainer>
                                {onSelectCards && (
                                    <BtnAction type="button" className="add" onClick={() => onSelectCards(cardsSelected)}>
                                        Adicionar
                                    </BtnAction>
                                )}
                            </TableActionButtonsContainer>
                        )}

                        <DialogAction
                            open={showRemoveDialog}
                            message={cardsSelected.length === 1
                                ? "Você deseja remover este item da seleção?"
                                : `Você deseja remover ${cardsSelected.length} itens da seleção?`}
                            actions_items={[
                                "Remoção dos itens selecionados desta vinculação"
                            ]}
                            disclaimer={"Esta ação apenas remove os itens desta vinculação, não excluirá os registros originais."}
                            onClose={() => setShowRemoveDialog(false)}
                            onSubmmit={() => handleRemoveDialogConfirm()}
                            type={1}
                        />
                    </> :
                    <></>
            }
        </Container>
    );

}

export default ComboBoxFlowTable;